module.exports = __webpack_public_path__ + "img/4x.b13ff47.jpg";